import { Card, CardContent, CardHeader, Typography } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { confirmMessage, confirmTitle } from "../features/AppSlice";

const Confirmation = () => {
  const confirmationText = useSelector(confirmMessage);
  const confirmationHeader = useSelector(confirmTitle);
  return (
    <Card>
      <CardHeader title={confirmationHeader} />
      <CardContent>
        <Typography>{confirmationText}</Typography>
      </CardContent>
    </Card>
  );
};

export default Confirmation;
